import { getController, getMessages } from '../../../../store/constants';
import { ActionCreator } from 'redux';
import { Dispatch, ThunkAction } from '../../../../types/actions';
import { ECardField } from '../store/listViewBoard/types';

const GA_CATEGORY = getMessages().getText('ga.category.list_view');
const GA_ACTION_DRAG = getMessages().getText('ga.action.list_view.drag');
const GA_ACTION_GROUP_ON = getMessages().getText('ga.action.list_view.group.on');
const GA_ACTION_GROUP_OFF = getMessages().getText('ga.action.list_view.group.off');
const GA_ACTION_GROUPS_COLLAPSE = getMessages().getText('ga.action.list_view.groups.collapse');
const GA_ACTION_GROUPS_EXPAND = getMessages().getText('ga.action.list_view.groups.expand');
const GA_ACTION_GROUP_COLLAPSE = getMessages().getText('ga.action.list_view.group.collapse');
const GA_ACTION_GROUP_EXPAND = getMessages().getText('ga.action.list_view.group.expand');
const GA_ACTION_PRINT = getMessages().getText('ga.action.list_view.print');
const GA_ACTION_RESET = getMessages().getText('ga.action.list_view.reset');
const GA_ACTION_SORT_TYPE_BY_CHRONOLOGICAL = getMessages().getText('ga.action.list_view.sortType.chronological');
const GA_ACTION_SORT_TYPE_MANUAL = getMessages().getText('ga.action.list_view.sortType.manual');
const GA_ACTION_SORT_FIELD = 'ga.action.list_view.sort.';
const GA_ACTION_FIELD_SHOW = 'ga.action.list_view.show.';
const GA_ACTION_FIELD_HIDE = 'ga.action.list_view.hide.';

export const listViewGoogleAnalyticsEvents: ActionCreator<ThunkAction> = (
    gaAction: string
) => {
    const action = (dispatch: Dispatch) => {
        getController().trackEvent(
            GA_CATEGORY,
            gaAction,
        )
    }
    return action;
};

export const dragGoogleAnalyticsEvents: ActionCreator<ThunkAction> =
() => {
    const action = (dispatch: Dispatch) => {
        dispatch(listViewGoogleAnalyticsEvents(GA_ACTION_DRAG));
    }
    return action;
};

export const groupsToggleGoogleAnalyticsEvents: ActionCreator<ThunkAction> = (
    collapse: boolean
) => {
    const action = (dispatch: Dispatch) => {
        const gaAction = collapse ? GA_ACTION_GROUPS_COLLAPSE : GA_ACTION_GROUPS_EXPAND;
        dispatch(listViewGoogleAnalyticsEvents(gaAction));
    }
    return action;
};

export const groupToggleGoogleAnalyticsEvents: ActionCreator<ThunkAction> = (
    collapse: boolean
) => {
    const action = (dispatch: Dispatch) => {
        const gaAction = collapse ? GA_ACTION_GROUP_COLLAPSE : GA_ACTION_GROUP_EXPAND;
        dispatch(listViewGoogleAnalyticsEvents(gaAction));
    }
    return action;
};

export const groupByEpicsGoogleAnalyticsEvents: ActionCreator<ThunkAction> = (
    active: boolean
) => {
    const action = (dispatch: Dispatch) => {
        const gaAction = active ? GA_ACTION_GROUP_ON : GA_ACTION_GROUP_OFF;
        dispatch(listViewGoogleAnalyticsEvents(gaAction));
    }
    return action;
};

export const printGoogleAnalyticsEvents: ActionCreator<ThunkAction> =
() => {
    const action = (dispatch: Dispatch) => {
        dispatch(listViewGoogleAnalyticsEvents(GA_ACTION_PRINT));
    }
    return action;
};

export const settingsResetGoogleAnalyticsEvents: ActionCreator<ThunkAction> =
() => {
    const action = (dispatch: Dispatch) => {
        dispatch(listViewGoogleAnalyticsEvents(GA_ACTION_RESET));
    }
    return action;
};

export const showFieldGoogleAnalyticsEvents: ActionCreator<ThunkAction> = (
    field: ECardField,
    active: boolean
) => {
    const action = (dispatch: Dispatch) => {
        const gaActionDo = active ? GA_ACTION_FIELD_SHOW : GA_ACTION_FIELD_HIDE;
        const gaAction = getMessages().getText(gaActionDo + field);
        dispatch(listViewGoogleAnalyticsEvents(gaAction));
    }
    return action;
};

export const sortFieldGoogleAnalyticsEvents: ActionCreator<ThunkAction> = (
    field: ECardField
) => {
    const action = (dispatch: Dispatch) => {
        const gaAction = getMessages().getText(GA_ACTION_SORT_FIELD + field);
        dispatch(listViewGoogleAnalyticsEvents(gaAction));
    }
    return action;
};
